export namespace RegexConstants {
  export const NumeroOrgaAffiliation = /\d{9}/;
  //   export const AllPhone = /0[1-9]\d{8}/;
  export const AllPhone = /^((\+)33|0|0033|33)([1-7]|9)\d{8}$/; //French validate number, bloquer les 08. //Num international : commence par 33, 0033, 0,+33
  export const Mobile = /0[6-7]\d{8}/;
  export const ChequeNumber = /\d{5,9}/;
  export const LocalPhone = /0[1-5|8-9]\d{8}/;
  export const Mail =
    /^(([^<>()\[\]\\.,;:\s@+"àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]+(\.[^<>()\[\]\\.,;:\s@+"àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  export const IbanAT = /AT\d{2}.{16}/;
  export const IbanBE = /BE\d{2}.{12}/;
  export const IbanDE = /DE\d{2}.{18}/;
  export const IbanEE = /EE\d{2}.{16}/;
  export const IbanES = /ES\d{2}.{20}/;
  export const IbanFI = /FI\d{2}.{14}/;
  export const IbanFR = /FR\d{2}.{23}/;
  export const IbanGR = /GR\d{2}.{23}/;
  export const IbanIE = /IE\d{2}.{18}/;
  export const IbanIT = /IT\d{2}.{23}/;
  export const IbanMT = /MT\d{2}.{27}/;
  export const IbanNL = /NL\d{2}.{14}/;
  export const IbanLT = /LT\d{2}.{16}/;
  export const IbanLV = /LV\d{2}.{17}/;
  export const IbanLU = /LU\d{2}.{16}/;
  export const IbanSI = /SI\d{2}.{15}/;
  export const IbanSK = /SK\d{2}.{20}/;
  export const IbanPT = /PT\d{2}.{21}/;
  export const IbanCY = /CY\d{2}.{24}/;
  export const Siret = /\d{14}/;
  export const Siren = /\d{9}/;
  export const CodeSignature = /\d{6}/;
  export const Date = /\d{2}\/\d{2}\/\d{4}/;
  export const Name =
    /^[A-Z0-9 a-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇæœ\-']+$/;
  export const NameStr =
    /^[A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇæœ' -]+$/;
  export const Password = {
    AtLeastOneNumber: /[0-9]+/,
    AtLeastOneUpperChar: /[A-Z]+/,
    AtLeast8Chars: /.{8,}/,
  };

  // export const POSTAL_CODE = /^(?:[0-8]\d|9[0-8])\d{3}$/;
  export const POSTAL_CODE = /^(?:0[1-9]|[1-8][0-9]|9[0-5])\d{3}$/; //Updated : blocked 96, 97, 98 bloque pour des regles de commercialisation non autorisee
  export const CarImmatriculation =
    /^(([0-9]{1,4}[-|\s]?[a-zA-Z]{2,3}[-|\s]?([0-9]{2}|2[AaBb]))|([a-zA-Z]{2}[-|\s]?[0-9]{3}[-|\s]?[a-zA-Z]{2}))$/;

  export const StyleTag = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi;

  export const WzPublicId = /(..)(...)(...)(...)(.*)/;
}
